import { useQuery } from "@tanstack/react-query";
import { fetchPayableInvoices } from "@/api/v1-jwt/invoice/invoice";
import { useAuth } from "@/providers/auth";

export const usePayableInvoices = ({
  queryFn,
  queryKey,
  enabled,
  filters = {},
  ...rest
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!id && enabled !== false;

  return useQuery({
    queryKey: ["invoices", "payables", filters],
    queryFn: async () => {
      return await fetchPayableInvoices({
        userId: id,
        filters,
      });
    },
    enabled: isEnabled,
    staleTime: 30000,
    ...rest,
  });
};
